"use client";

import { MainContainer } from "@/components/atoms/MainContainer/MainContainer";
import { SectionContainer } from "@/components/atoms/SectionContainer/SectionContainer";
import RichText from "@/components/atoms/RichText/RichText";
import { Gallery } from "@/components/molecules/Gallery/Gallery";
import { ContentPageContentProps } from "@/app/[locale]/bjorn/_lib/page.types";

export function ContentPage({ page }: Readonly<ContentPageContentProps>) {
  return (
    <MainContainer>
      {page.introduction && (
        <SectionContainer>
          <RichText body={page.introduction} imgWidth={400} />
        </SectionContainer>
      )}
      {page.media && (
        <SectionContainer>
          <Gallery media={page.media} />
        </SectionContainer>
      )}
      {page.text && (
        <SectionContainer>
          <RichText body={page.text} imgWidth={600} />
        </SectionContainer>
      )}
    </MainContainer>
  );
}
